import React, {useState, useEffect} from 'react'
import cn from "classnames"
import pageBg from  '../../img/backpackPage-bg.webp'
import backpackPageItemBg from '../../img/backpack-bg.png'
import backpackPageItemImg1 from '../../img/backpack-page-item-1.png'
import backpackPageItemImg2 from '../../img/backpack-page-item-2.png'
import backpackPageItemImg3 from '../../img/backpack-page-item-3.png'
import backpackPageItemImg4 from '../../img/backpack-page-item-4.png'
import backpackPageItemImg5 from '../../img/backpack-page-item-5.png'
import backpackPageItemImg6 from '../../img/backpack-page-item-6.png'
import {Preloader, SideParameters, SpriteSvg} from '../../components'

const BackpackPage = ({
	handleNextPage,
	name,
	isLoaded,
	setIsLoaded,
	isRouteTraveled,
	gameEnded,
	mapPage,
	afterMeadowGamePage,
	afterWaterfallGamePage,
	afterTrailGamePage,
	afterPeaksGamePage,
	afterCampGamePage,
	afterMountainGamePage,
}) => {

	const [isVisibleContent, setIsVisibleContent] = useState(false)



	useEffect(()=> {
		setTimeout(()=> {
			setIsVisibleContent(true)
		},5000)
	},[])

	return (
		<>
			<Preloader isLoaded={isLoaded} setIsLoaded={setIsLoaded}/>

			<div className={cn(
				'full-page',
				'backpack-page',
				isLoaded && 'active'
			)}
			>
				{gameEnded(isRouteTraveled) === 6 &&
					<SideParameters
						knowledge={4} skill={4} exp={4} dexterity={4} strong={4}
					/>
				}
				{gameEnded(isRouteTraveled) === 5 &&
					<SideParameters
						knowledge={4} skill={4} exp={4} dexterity={4} strong={4}
					/>
				}
				{gameEnded(isRouteTraveled) === 4 &&
					<SideParameters
						knowledge={4} skill={4} exp={3} dexterity={3} strong={2}
					/>
				}
				{gameEnded(isRouteTraveled) === 3 &&
					<SideParameters
						knowledge={3} skill={3} exp={3} dexterity={3} strong={2}
					/>
				}
				{gameEnded(isRouteTraveled) === 2 &&
					<SideParameters
						knowledge={2} skill={3} exp={3} dexterity={2} strong={1}
					/>
				}{gameEnded(isRouteTraveled) === 1 &&
				<SideParameters
					knowledge={2} skill={2} exp={2} dexterity={1} strong={1}
				/>
			}

				<div className="page-bg">
					<img className='bg-img' src={pageBg} alt=""/>
				</div>

				<div className={cn(
					'page-content',
					isVisibleContent &&
					'active'
				)}>


					<div className={cn(
						'content',
						'center',
					)}>
						<div className="title">
							<p>Всё самое нужное</p>
						</div>

						<div className="list grid-3">
							<div className="item">
								<img className='item-bg' src={backpackPageItemBg} alt=""/>
								{isRouteTraveled.includes(afterMeadowGamePage)
									? <img className='item-img' src={backpackPageItemImg1} alt=""/>
							  	: <div className="title"><p>Запасное место</p></div>
								}
							</div>

							<div className="item">
								<img className='item-bg' src={backpackPageItemBg} alt=""/>
								{isRouteTraveled.includes(afterWaterfallGamePage) &&
									isRouteTraveled.includes(afterMeadowGamePage)
									? <img className='item-img' src={backpackPageItemImg2} alt=""/>
									: <div className="title"><p>Запасное место</p></div>
								}
							</div>

							<div className="item">
								<img className='item-bg' src={backpackPageItemBg} alt=""/>
								{isRouteTraveled.includes(afterTrailGamePage) &&
									isRouteTraveled.includes(afterWaterfallGamePage) &&
									isRouteTraveled.includes(afterMeadowGamePage)
									? <img className='item-img' src={backpackPageItemImg3} alt=""/>
									: <div className="title"><p>Запасное место</p></div>
								}
							</div>

							<div className="item">
								<img className='item-bg' src={backpackPageItemBg} alt=""/>
								{isRouteTraveled.includes(afterPeaksGamePage) &&
									isRouteTraveled.includes(afterTrailGamePage) &&
									isRouteTraveled.includes(afterWaterfallGamePage) &&
									isRouteTraveled.includes(afterMeadowGamePage)
									? <img className='item-img' src={backpackPageItemImg4} alt=""/>
									: <div className="title"><p>Запасное место</p></div>
								}
							</div>

							<div className="item">
								<img className='item-bg' src={backpackPageItemBg} alt=""/>
								 {isRouteTraveled.includes(afterCampGamePage) &&
									isRouteTraveled.includes(afterPeaksGamePage) &&
									isRouteTraveled.includes(afterTrailGamePage) &&
									isRouteTraveled.includes(afterWaterfallGamePage) &&
									isRouteTraveled.includes(afterMeadowGamePage)
									? <img className='item-img' src={backpackPageItemImg5} alt=""/>
									: <div className="title"><p>Запасное место</p></div>
								}
							</div>

							<div className="item">
								<img className='item-bg' src={backpackPageItemBg} alt=""/>
									  {isRouteTraveled.includes(afterMountainGamePage) &&
									   isRouteTraveled.includes(afterCampGamePage) &&
										 isRouteTraveled.includes(afterPeaksGamePage) &&
										 isRouteTraveled.includes(afterTrailGamePage) &&
										 isRouteTraveled.includes(afterWaterfallGamePage) &&
										 isRouteTraveled.includes(afterMeadowGamePage)
									? <img className='item-img' src={backpackPageItemImg6} alt=""/>
									 : <div className="title"><p>Запасное место</p></div>
								}
							</div>
						</div>

						<div className="btn-wrap right">
							<div onClick={()=> handleNextPage(mapPage)} className="btn green" style={{width: '210px'}}>
								<SpriteSvg id='train-station-page-btn-green-bg'/>
								<p>В путь!</p>
							</div>
						</div>
					</div>

				</div>

			</div>
		</>
	)
}

export default BackpackPage